import React, { useEffect, useState } from "react";
import "../../../modal.css";

import Avatar from "../../../static/images/avata.svg";
import { formateDateTime } from "../../../utils";

export default function CallBackSelection({ message, selectOption, displayAllOptions, scrollToBottom, isHistoryMessgage, agentName, GAEvent, scrollintoview, id }) {
    const [slotsGroup, setSlotsGroup] = useState(null)
    const [selectedDate, selectDate] = useState(null)
    const content = JSON.parse(message.content)
    useEffect(() => {
        GAEvent({ eventAction: "request-a-callback-selected", eventLabel: "timeslots-displayed" })
        let choices = content.choices
        let json = {}
        for (let slots of choices) {
            json[slots.display_discription] = json?.[slots.display_discription] ? [...json?.[slots.display_discription], slots] : [slots]
        }
        setSlotsGroup(json)
        selectDate(Object.keys(json)[0])
        // console.log(json)
    }, [message])
    // console.log(Object.keys(slotsGroup))
    return (
        <>
        {content.title ? (
            <>
                <div class="grop_message">
                    <div
                        class="message"
                        dangerouslySetInnerHTML={{ __html: content.title }}
                    />
                </div>

                {/* <img class="grop_message blank" >
                                </img>
                <div class=" grop_message msg-detials">
                PB Chat <i/>{formateDateTime(message.sentAt)}
                </div> */}

            </>
        ) : null}
        
        {isHistoryMessgage || message.selected ? null :
        <div class="slotwrapper">
            <div class="time-slot-day">
                <ul class="slot">
                    {slotsGroup ? Object.keys(slotsGroup).map((key) =>
                        <li onClick={()=> selectDate(key)} className={`${key === selectedDate? "selected":null}`}>{key}</li>
                    ) : null}
                </ul>

            </div>
            <div class="time-slot">
                <ul class="slot">
                    {slotsGroup? slotsGroup[selectedDate].map((item)=>
                    <li onClick={() => {selectOption(item, content.type, message.messageId)
                    GAEvent({eventAction:"request-a-callback-scheduled",eventLabel:item.display_value})}}>{item.display_value}</li>
                    ):null}
                   

                </ul>

            </div>
        </div>
}
</>
    );
}